import axios from "axios";

export default axios.create({
    baseURL: process.env.NEW_API_URL,
    responseType: "json"
});